/**
 * Format the file size to a human readable string
 * @param bytes - The file size in bytes
 * @example
 * formatFileSize(1024) // "1 KB"
 * formatFileSize(1024 * 1024) // "1 MB"
 * formatFileSize(1024 * 1024 * 1024) // "1 GB"
 * @returns The file size in a human readable string
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
}
